import { Controller } from 'react-hook-form'
import * as z from 'zod'

import { FormItem } from '~/shadcn/ui/form/form'
import { TextTooltip } from '~/@mid_ui/text-tooltip/TextTooltip'
import { CurrencyInput } from '~/@mid_ui-form/currency-input/CurrencyInput'
import { FormStep } from '~/@pages_onboarding/investor-analysis/_analysis-form/FormStep'
import { StepTitle } from '~/@pages_onboarding/investor-analysis/_analysis-form/StepTitle'
import { stringNumberSchema } from '~/@pages_onboarding/investor-analysis/_analysis-form/schemas'
import { useFormStepUnsophisticated } from '../../form-step-unsophisticated/useFormStepUnsophisticated'
import { useQuestionsV1 } from '../../../questions'

const step2Schema = z.object({ assetsValue: stringNumberSchema })
export type Step2Data = z.infer<typeof step2Schema>

export function Step2() {
  const { onStepCompleted, formData } = useFormStepUnsophisticated()
  const { unsophisticated: unsophisticatedQuestions } = useQuestionsV1()

  return (
    <FormStep
      defaultValues={formData}
      schema={step2Schema}
      onStepCompleted={onStepCompleted}
      render={({ control }) => (
        <>
          <StepTitle>
            {unsophisticatedQuestions.assetsValue.question.label}
          </StepTitle>

          <Controller
            name="assetsValue"
            control={control}
            render={({ fieldState, field }) => (
              <FormItem>
                <CurrencyInput
                  autoFocus
                  aria-invalid={!!fieldState?.error}
                  labelText="Hodnota majetku"
                  value={field.value}
                  onChangeValue={field.onChange}
                  className="lg:w-60"
                />
              </FormItem>
            )}
          />

          <div className="flex items-center gap-2">
            <TextTooltip
              text={
                'Výšku majetku môžete vypočítať odčítaním vašich dlhov a záväzkov od hodnoty všetkých aktív, ktoré vlastníte.'
              }
              triggerContent="Ako správne vypočítať výšku majetku?"
            />
          </div>
        </>
      )}
    />
  )
}
